export const convertTimeRangeToDateFormat = ({ from, to }: { from: Date; to: Date }) => ({
  from: from.getTime(),
  to: to.getTime(),
})
